import React, { useEffect } from "react";
import {
  HashRouter as Router,
  Switch,
  Route,
  useLocation,
} from "react-router-dom";
import HomeScreen from "./screen/HomeScreen";
import FaqGovernmentActRegulations from "./screen/FaqGovernmentActRegulations";
import FaqPrimaryIssuances from "./screen/FaqPrimaryIssuances";
import FaqRbiRetailDirect from "./screen/FaqRbiRetailDirect";
import FaqGoldBonds from "./screen/FaqGoldBonds";
import FaqNdsOmSecondaryMarket from "./screen/FaqNdsOmSecondaryMarket";
import FaqGovernmentSecurities from "./screen/FaqGovernmentSecurities";
import AbtScheme from "./screen/AbtScheme";
import AbtRbiRetailDirectRegulations from "./screen/AbtRbiRetailDirectRegulations";
import AbtInvestorCharter from "./screen/AbtInvestorCharter";
import AbtAuctionCalendar from "./screen/AbtAuctionCalendar";
import AbtStatistics from "./screen/AbtStatistics";
import Disclaimer from "./screen/Disclaimer";
import Contact from "./screen/Contact";
import News from "./screen/News";
import Tour from "./screen/Tour";
import PrivacyPolicy from "./screen/PrivacyPolicy";
import TourSingle from "./screen/TourSingle";
const App = () => {
  
  return (
    <Router>
    <Switch>
      <Route path="/" exact component={HomeScreen} />
      <Route path="/FaqGovernmentActRegulations" exact component={FaqGovernmentActRegulations} />
      <Route path="/FaqPrimaryIssuances" exact component={FaqPrimaryIssuances} />
      <Route path="/FaqRbiRetailDirect" exact component={FaqRbiRetailDirect} />
      <Route path="/FaqGoldBonds" exact component={FaqGoldBonds} />
      <Route path="/FaqNdsOmSecondaryMarket" exact component={FaqNdsOmSecondaryMarket} />
      <Route path="/FaqGovernmentSecurities" exact component={FaqGovernmentSecurities} />
      <Route path="/about_scheme" exact component={AbtScheme} />
      <Route path="/about_rbi_retail" exact component={AbtRbiRetailDirectRegulations} />
      <Route path="/about_investor" exact component={AbtInvestorCharter} />
      <Route path="/about_auction_calendar" exact component={AbtAuctionCalendar} />
      <Route path="/about_statistics" exact component={AbtStatistics} />
      <Route path="/Disclaimer" exact component={Disclaimer} />
      <Route path="/News" exact component={News} />
      <Route path="/Contact" exact component={Contact} />
      <Route path="/Tour" exact component={Tour} />
      <Route path="/PrivacyPolicy" exact component={PrivacyPolicy} />
      <Route path="/TourSingle" exact component={TourSingle} />
    </Switch>
  </Router>
  );
};

export default App;
